import React from "react";
import { v4 as uuidv4 } from "uuid";
import Input from "../../common/input";
import ICON_CHAT from "../icons/chat.svg";
import ucaEnv from "../../../common/env/env-uca";
import { useApi } from "../../../hooks";
import { CommonModule } from "uca-react-containers-library";

import "./help.scss";

const HelpSearch = ({ isGuest, banner }) => {
  let apiResponse;
  if (!isGuest) {
    const {
      appData: { env, platform },
    } = CommonModule.useApp();
    const environmentVariables = ucaEnv(banner, env, platform);
    const { data } = useApi(
      `${environmentVariables.AUTH_API}&rand=${uuidv4()}`,
      { withCredentials: true }
    );
    apiResponse = data;
  }

  const handleChatbot = () => {
    Inq.fireCustomEvent("fireIconClicked");
  };

  const chatNowInput = () => {
    Inq.fireCustomEvent("fireTextBoxClicked");
  };

  const firstName =
    apiResponse && apiResponse.firstName
      ? apiResponse.firstName.charAt(0).toUpperCase() +
        apiResponse.firstName.slice(1) +
        "!"
      : "";
  const searchTitle = !isGuest ? `Hi, ${firstName}` : "";

  return (
    <div className="help-search-wrapper">
      <h1 className="title1 mt-4">{searchTitle} How can we help?</h1>
      {/* <div className="input-wrapper d-inline-block w-100">
        <img src={ICON_CHAT} alt="Chatbot Icon" onClick={handleChatbot} />
        <input
          type="text"
          className="text-center pl-5"
          placeholder='"How can I get a refund?"'
          onClick={chatNowInput}
          readOnly={true}
        />
      </div> */}
      {/* <div className="help-search-autocomplete">
        <h4>Top Topics</h4>
        <ul className="list">
          <li>How do i reclaim expired rewards?</li>
          <li>How do i reclaim expired rewards?</li>
          <li>How do i reclaim expired rewards?</li>
          <li>How do i reclaim expired rewards?</li>
        </ul>
      </div> */}
    </div>
  );
};

export default HelpSearch;
